import React, { useState, useContext } from "react";
import "./ModelOne.scss";
import cx from "classnames";
import { ShapeContext } from "../../ShapeContext";
import { SquareContext } from "../../SquareContext";
import {DelayInput} from 'react-delay-input';
import { useMediaQuery } from "react-responsive";

function ModelSix(props) {
  const {
    box1c,
    setBox1c,
    box2c,
    setBox2c,
    box3c,
    setBox3c,
    box4c,
    setBox4c,
    box1r,
    setBox1r,
    box2r,
    setBox2r,
    box3r,
    setBox3r,
    box4r,
    setBox4r,
    box1l,
    setBox1l,
    box2l,
    setBox2l,
    box3l,
    setBox3l,
    box4l,
    setBox4l,
    box1t,
    setBox1t,
    box2t,
    setBox2t,
    box3t,
    setBox3t,
    box4t,
    setBox4t,
  } = useContext(ShapeContext);

  const {
    cmMM,
    setInVal,
    setInVal2,
    inVal,
    inVal2,
    inVal3,
    setInVal3,
    inVal4,
    setInVal4,
    inVal5,
    setInVal5,
    inVal6,
    setInVal6,
    inVal7,
    setInVal7,
    inVal8,
    setInVal8,
    handleNumber,
    maxLengthCheck ,
    measureId
  } = useContext(SquareContext);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1350px)" });
  const isMobile = useMediaQuery({ query: "(min-width: 600px)" });

  return (
    <>
      <div className="model">
        
        {/* --------------------------------------------left-small---------------------------------------------------- */}
        {!isTabletOrMobile && (
          <div className="left-div">
            <div className="model-one-input-down int1">
              <div className="model-input-l2">
                <DelayInput
                  className="ipt2"
                  type="number"
                  delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                  value={inVal6}
                  onChange={(e) => handleNumber(e, setInVal6)}
                  autoComplete="off"
                  id="qt"
                  name="qt"
                  min="0"
                 
                ></DelayInput>
                {cmMM}
              </div>
            </div>
          </div>
        )}
        <div className="small-cont">
          
          <div>
            <div className="model-box-left-small">
              {!isMobile && <span className="span3">3</span>}
              <div className="bar-left-3">
                <div
                  className={cx("triangle-left-3", box2l ? "active" : "")}
                  onClick={() => (!box2l ? setBox2l(true) : setBox2l(false))}
                ></div>
              </div>
              <div className="bar-top-3">
                <div
                  className={cx("triangle-top-3", box1l ? "active" : "")}
                  onClick={() => (!box1l ? setBox1l(true) : setBox1l(false))}
                ></div>
              </div>
              <div className="bar-right-3">
                <div
                  className={cx("triangle-right-3", box4l ? "active" : "")}
                  onClick={() => (!box4l ? setBox4l(true) : setBox4l(false))}
                ></div>
              </div>
              <div className="bar-bottom-3">
                <div
                  className={cx("triangle-bottom-3", box3l ? "active" : "")}
                  onClick={() => (!box3l ? setBox3l(true) : setBox3l(false))}
                ></div>
              </div>
              {isTabletOrMobile && isMobile && (
                <div className="model-one-input-down int1">
                  <div className="model-input-l22">
                    <DelayInput
                      className="ipt2"
                      type="number"
                      delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                      value={inVal6}
                      onChange={(e) => handleNumber(e, setInVal6)}
                      autoComplete="off"
                      id="qt"
                      name="qt"
                      min="0"
                     
                    ></DelayInput>
                    {cmMM}
                  </div>
                </div>
              )}
            </div>
          </div>
          {isMobile && (
            <div className="model-one-input-down int1">
              <div className="model-input-d">
                <DelayInput
                  className="ipt1"
                  type="number"
                  delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                  value={inVal5}
                  onChange={(e) => handleNumber(e, setInVal5)}
                  autoComplete="off"
                  id="qt"
                  name="qt"
                  min="0"
                 
                ></DelayInput>
                {cmMM}
              </div>
            </div>
          )}
        </div>

        <div className="box-flex3">
          
          {/* -------------------------------------right-small------------------------------------------------------- */}
          <div className="right-small-container">
          {isMobile && (
            <div className="model-six-input-left-right-small int1">
              <div className="model-input-rsm">
                <DelayInput
                  className="ipt1"
                  type="number"
                  delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                  value={inVal7}
                  onChange={(e) => handleNumber(e, setInVal7)}
                  autoComplete="off"
                  id="qt"
                  name="qt"
                  min="0"
                 
                ></DelayInput>
                {cmMM}
              </div>
            </div>
          )}
          <div className="model-box-right-small">
            
            {!isMobile && <span className="span5">4</span>}
            <div className="bar-top-5">
              <div
                className={cx("triangle-top-5", box1t ? "active" : "")}
                onClick={() => (!box1t ? setBox1t(true) : setBox1t(false))}
              ></div>
            </div>
            <div className="bar-left-5">
              <div
                className={cx("triangle-left-5", box2t ? "active" : "")}
                onClick={() => (!box2t ? setBox2t(true) : setBox2t(false))}
              ></div>
            </div>
            <div className="bar-bottom-5">
              <div
                className={cx("triangle-bottom-5", box3t ? "active" : "")}
                onClick={() => (!box3t ? setBox3t(true) : setBox3t(false))}
              ></div>
            </div>
            <div className="bar-right-5">
              {/* <div
                className={cx("triangle-right-5", box4t ? "active" : "")}
                onClick={() => (!box4t ? setBox4t(true) : setBox4t(false))}
              ></div> */}
            </div>
          </div>
          </div>
          {isMobile && (
            <div className="model-five-input-right int1">
              <div className="model-input-rsm">
                <DelayInput
                  className="ipt1"
                  type="number"
                  delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                  value={inVal8}
                  onChange={(e) => handleNumber(e, setInVal8)}
                  autoComplete="off"
                  id="qt"
                  name="qt"
                  min="0"
                 
                ></DelayInput>
                {cmMM}
              </div>
              
            </div>
            
          )}
          {/* -------------------------------------left-bottom------------------------------------------------------- */}
          <div>
        
            <div className="model-box-left-bottom">
              {!isMobile && <span className="span1">1</span>}
              <div className="bar-top">
                <div
                  className={cx("triangle-top", box1c ? "active" : "")}
                  onClick={() => (!box1c ? setBox1c(true) : setBox1c(false))}
                ></div>
              </div>
              <div className="bar-left">
                {/* <div
                className={cx("triangle-left", box2c ? "active" : "")}
                onClick={() => (!box2c ? setBox2c(true) : setBox2c(false))}
              ></div> */}
              </div>
              <div className="bar-bottom">
                <div
                  className={cx("triangle-bottom", box3c ? "active" : "")}
                  onClick={() => (!box3c ? setBox3c(true) : setBox3c(false))}
                ></div>
              </div>
              <div className="bar-right">
                {/* <div
                className={cx("triangle-right", box4c ? "active" : "")}
                onClick={() => (!box4c ? setBox4c(true) : setBox4c(false))}
              ></div> */}
              </div>

              {isMobile && (
                <div className="model-three-input-inside int2">
                  <div className="model-input-inside">
                    <DelayInput
                      className="ipt1"
                      type="number"
                      delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                      value={inVal}
                      onChange={(e) => handleNumber(e, setInVal)}
                      autoComplete="off"
                      id="qt"
                      name="qt"
                      min="0"
                     
                    ></DelayInput>
                    {cmMM}
                  </div>
                </div>
              )}
            </div>

            {isMobile && (
              <div className="model-one-input-down int1">
                <div className="model-input-d">
                  <DelayInput
                    className="ipt1"
                    type="number"
                    delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                    value={inVal2}
                    onChange={(e) => handleNumber(e, setInVal2)}
                    autoComplete="off"
                    id="qt"
                    name="qt"
                    min="0"
                   
                  ></DelayInput>
                  {cmMM}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* -------------------------------------right-bottom------------------------------------------------------- */}
        <div>
          <div className="model-box-right-bottomj">
            {!isMobile && <span className="span2">2</span>}
            <div className="bar-left-2j">
              <div
                className={cx("triangle-left-2j", box2r ? "active" : "")}
                onClick={() => (!box2r ? setBox2r(true) : setBox2r(false))}
              ></div>
            </div>
            <div className="bar-top-2j">
              <div
                className={cx("triangle-top-2j", box1r ? "active" : "")}
                onClick={() => (!box1r ? setBox1r(true) : setBox1r(false))}
              ></div>
            </div>
            <div className="bar-right-2j">
              <div
                className={cx("triangle-right-2j", box4r ? "active" : "")}
                onClick={() => (!box4r ? setBox4r(true) : setBox4r(false))}
              ></div>
            </div>
            <div className="bar-bottom-2j">
              <div
                className={cx("triangle-bottom-2j", box3r ? "active" : "")}
                onClick={() => (!box3r ? setBox3r(true) : setBox3r(false))}
              ></div>
            </div>
            {isTabletOrMobile && isMobile && (
              <div className="model-one-input-down int1">
                <div className="model-input-r22j">
                  <DelayInput
                    className="ipt1"
                    type="number"
                    delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                    value={inVal4}
                    onChange={(e) => handleNumber(e, setInVal4)}
                    autoComplete="off"
                    id="qt"
                    name="qt"
                    min="0"
                   
                  ></DelayInput>
                  {cmMM}
                </div>
              </div>
            )}
          </div>
          {isMobile && (
            <div className="model-one-input-down int1">
              <div className="model-input-d">
                <DelayInput
                  className="ipt1"
                  type="number"
                  delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                  value={inVal3}
                  onChange={(e) => handleNumber(e, setInVal3)}
                  autoComplete="off"
                  id="qt"
                  name="qt"
                  min="0"
                 
                ></DelayInput>
                {cmMM}
              </div>
            </div>
          )}
        </div>
        {!isTabletOrMobile && (
          <div className="right-div">
            <div className="model-one-input-down int1">
              <div className="model-input-r2">
                <DelayInput
                  className="ipt1"
                  type="number"
                  delayTimeout={600} 
                 onInput={maxLengthCheck}
                 maxLength={measureId.id === 1 || measureId.id === 3 ? 4 : 6}
                  onInput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  value={inVal4}
                  onChange={(e) => handleNumber(e, setInVal4)}
                  autoComplete="off"
                  id="qt"
                  name="qt"
                  min="0"
                 
                  pattern="[0-9]*"
                ></DelayInput>
                {cmMM}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ModelSix;
